"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandSetupActionCard = void 0;
var react_1 = __importDefault(require("react"));
var BannerActionCard_1 = require("Dashboard/OnboardingBanner/ActionCards/BannerActionCard");
var inversify_react_1 = require("inversify-react");
var UseHistoryTypes_1 = require("DataStores/User/UseHistory/UseHistoryTypes");
var mobx_react_1 = require("mobx-react");
var OpenBrandSetup_1 = __importDefault(require("DreamCoat/BrandSetUp/OpenBrandSetup"));
var OnboardingBannerTelemetry_1 = __importDefault(require("Dashboard/OnboardingBanner/OnboardingBannerTelemetry"));
exports.BrandSetupActionCard = (0, mobx_react_1.observer)(function (_a) {
    var promptId = _a.promptId;
    var cardId = UseHistoryTypes_1.PagesOnboardingBannerAction.BrandSetup;
    var promptHistory = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore.useHistoryDataStore
        .inlinePromptsHistoryStore;
    var di = (0, inversify_react_1.useInjection)("di");
    var onboardingBannerTelemetry = (0, inversify_react_1.useInjection)(OnboardingBannerTelemetry_1.default);
    var openBrandSetup = di.invoke(OpenBrandSetup_1.default);
    var isCompleted = promptHistory.getCompletedActions(promptId).includes(cardId);
    return (react_1.default.createElement(BannerActionCard_1.BannerActionCard, { key: cardId, label: "Setup your brand", title: "Add your colours and fonts to style every page", thumbnailUrl: "/Assets/Images/onboarding/dashboard-banner/pages-banner-setup-brand-action.png", isCompleted: isCompleted, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                onboardingBannerTelemetry.cardClicked(promptId, cardId).catch(function (e) { });
                openBrandSetup();
                promptHistory.setActionCompleted(promptId, cardId);
                return [2];
            });
        }); } }));
});
